import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Globals } from 'src/app/globals';
import { EnrollmentAcceptedStudentService } from '../../../service/enrollmentAcceptedStudent.service';
import { CoursesService } from '../../../service/courses.service';
import { GradeSubjectService } from '../../../service/grade-subject.service';
import { ToastrService } from 'ngx-toastr';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { FileService } from 'src/app/service/file.service';
import { Router } from '@angular/router';
import { Console } from 'console';
import { SystemService } from 'src/app/service/system.service';
declare var $: any;


@Component({
  selector: 'app-add-student',
  templateUrl: './add-student.component.html',
  styleUrls: ['./add-student.component.scss']
})
export class AddStudentComponent implements OnInit {

  editable: boolean = false;
  showLoader: boolean = false;
  loadingStudentRepeater: boolean = false;
  showRepeaterTableError: boolean = false;
  showStudentInfo: boolean = false;
  candImageFile: any;
  candImageUrl: any;
  candUploadImage: any;
  candImageFileName: any;
  studentStates: any;
  semesters: any;
  batchs: any;
  studentInfo: any;
  table: any;
  repeaters: any;
  repeaterSubjectCode: any = "";
  repeaterSubjectId: any = "";
  repeaterSubjectName: any = "";
  repeaterAcademicYear: any = "";
  repeaterSemester: any = "";
  repeaterBatchId: any = "";
  repeaterBatchName: any = "";
  repeaterStatusId: any = "";
  currentRepeaterIndex: any = "";
  currentRepeaterId: any = "";
  username: any;
  orgId: any;
  courses: any;
  subjectCode: any = "";
  // subjectName: any = "";
  academicYear: any;
  semesterCode: any;
  subjectStates:any;
  semesterDes:any;
  yearDes:any;
  // showStudentSearchError: any = false;

  // studentImageUrl: any = "https://gravatar.com/avatar/ae4e3e608c9496ff0a04d46b0304cbe8?s=400&d=robohash&r=x";
  studentImageUrl: any = "assets/images/stud-image.png";

  findStudent = new FormGroup({
    matNo: new FormControl('', [
      Validators.required,
    ]),
    // studentFullName: new FormControl('', [
    //   Validators.required,
    // ])
  });

  addStudentForm = new FormGroup({
    fullNameAr: new FormControl('', [
      Validators.required,
    ]),
    firstNameAr: new FormControl('', [
      Validators.required,
    ]),
    lastNameAr: new FormControl('', [
      Validators.required,
    ]),
    fullNameEnglish: new FormControl('', [
      Validators.required,
    ]),
    firstNameEn: new FormControl('', [
      Validators.required,
    ]),
    lastNameEn: new FormControl('', [
      Validators.required,
    ]),
    gender: new FormControl('', [
      Validators.required,
    ]),
    email: new FormControl('', [
      Validators.required,
      Validators.pattern(/^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/),

    ]),
    phoneNumber: new FormControl('', [
      Validators.required,
      Validators.maxLength(11),
      Validators.minLength(11),
      Validators.pattern('[0][1](1|2|5|0)[0-9]{8}'),
    ]),
    address: new FormControl('', [
      Validators.required,
    ]),
    studentState: new FormControl('', [
      Validators.required,
    ]),
    semester: new FormControl('', [
      Validators.required,
    ]),
    batch: new FormControl('', [
      Validators.required,
    ]),
    matNo: new FormControl('', [
      Validators.required,
    ]),
    nationalId: new FormControl('', [
      Validators.required,
      Validators.pattern(/(2|3)[0-9][0-9][0-1][0-9][0-3][0-9](01|02|03|04|11|12|13|14|15|16|17|18|19|21|22|23|24|25|26|27|28|29|31|32|33|34|35|88)\d\d\d\d\d/)

    ]),
    picture: new FormControl('', [
      //Validators.required,
    ]),
  });

  constructor(private toastrService: ToastrService, public enrollmentAcceptedStudentService: EnrollmentAcceptedStudentService, public globals: Globals, private router: Router, public translate: TranslateService, private fileService: FileService, private coursesService: CoursesService, private gradeSubjectService: GradeSubjectService,private systemService:SystemService) { }

  ngOnInit(): void {
    this.orgId = this.globals.currentUserInfo.orgid;
    this.academicYear = this.globals.currentUserInfo.yearid;
    this.semesterCode = this.globals.currentUserInfo.semesterid;
    this.username = this.globals.currentUserInfo.username;
    // INIT repearts with fake data
    // this.repeaters = [
    //   {
    //     id: 1,
    //     subjectCode: 1002,
    //     subjectName: "test name1",
    //     academicYear: 2021,
    //     semester: 20211,
    //     batch: "batch_1",
    //     status: "repeater",
    //   },
    //   {
    //     id: 2,
    //     subjectCode: 1004,
    //     subjectName: "test name2",
    //     academicYear: 2021,
    //     semester: 20211,
    //     batch: "batch_2",
    //     status: "audit",
    //   },
    // ];
    this.getStudentStatuses();
    this.getAllGradeSubject();
    this.getAllEelStudentStatus();
    this.getAllCourses();
    // Listen for language change to update table
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.updateTable();
      this.initFormDropDownsFields();
    });
  }

  // getStudent(){

  //   // Init fake data for testing
  //   this.studentInfo = {
  //     fullNameAr: "علي فرج",
  //     firstNameAr: "علي",
  //     lastNameAr: "فرج",
  //     fullNameEn: "ali farag",
  //     firstNameEn: "ali",
  //     lastNameEn: "farag",
  //     gender: "M",
  //     email: "ali.test@test.com",
  //     mobileNo: "01000000000",
  //     address: "address details",
  //     nidNo: "2040000000000",
  //     studentState: 10,
  //     semester: "spring",
  //     batch: "batch_1",
  //     matNo: "445",
  //   };


  //   this.addStudentForm.controls.fullNameAr.setValue(this.studentInfo.fullNameAr);
  //   this.addStudentForm.controls.firstNameAr.setValue(this.studentInfo.firstNameAr);
  //   this.addStudentForm.controls.lastNameAr.setValue(this.studentInfo.lastNameAr);
  //   this.addStudentForm.controls.fullNameEnglish.setValue(this.studentInfo.fullNameEn);
  //   this.addStudentForm.controls.firstNameEn.setValue(this.studentInfo.firstNameEn);
  //   this.addStudentForm.controls.lastNameEn.setValue(this.studentInfo.lastNameEn);
  //   this.addStudentForm.controls.gender.setValue(this.studentInfo.gender);
  //   this.addStudentForm.controls.email.setValue(this.studentInfo.email);
  //   this.addStudentForm.controls.phoneNumber.setValue(this.studentInfo.mobileNo);
  //   this.addStudentForm.controls.address.setValue(this.studentInfo.address);
  //   this.addStudentForm.controls.nationalId.setValue(this.studentInfo.nidNo);
  //   this.addStudentForm.controls.studentState.setValue(this.studentInfo.studentState);
  //   this.addStudentForm.controls.semester.setValue(this.studentInfo.semester);
  //   this.addStudentForm.controls.batch.setValue(this.studentInfo.batch);
  //   this.addStudentForm.controls.matNo.setValue(this.studentInfo.matNo);
  // }

  findStudentSubmit() {
    if (this.findStudent.valid) {
      // this.showStudentSearchError = false;
      // let studCode = this.findStudent.controls.matNo.value != '' ? this.findStudent.controls.matNo.value : this.findStudent.controls.studentFullName.value;
      let studCode = this.findStudent.controls.matNo.value;
      // For Testing
      this.getAcmSemester();
      this.getYearDes();
      this.getStudentByCode(studCode);
      
    } else {
      // this.showStudentSearchError = true;
      this.findStudent.markAllAsTouched();
      this.findStudent.markAsDirty();
    }
  }

  getAcmSemester() {
    this.systemService.getAcmSemester(this.globals.currentUserInfo.semesterid).subscribe(
      data => {
        this.semesterDes = data;
        // this.toastr.success("Basic Data Saved successfully");
      },
      error => {
        //this.creating = false
        this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
      },
      //() => this.creating = false

    );
  }
  
  getYearDes() {
    this.showLoader = true;
    this.systemService.getYear(this.academicYear).subscribe(
      data => {
        this.yearDes = data;
      },
      error => {

        this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        this.showLoader = false

      },
      () => this.showLoader = false
    );
  }
  findStudentChange() { }

  addStudentFormSubmit() { }
  addStudentFormChange() { }

  getStudentStatuses() {
    this.enrollmentAcceptedStudentService.getStudentStatuses()
      .subscribe(
        data => {
          this.studentStates = data;
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
  }

  getAllEelStudentStatus() {
    this.enrollmentAcceptedStudentService.getAllEelStudentStatus()
      .subscribe(
        data => {
          this.subjectStates = data;
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
  }

  getStudentByCode(codeOrName: any) {
    this.showLoader = true;
    this.enrollmentAcceptedStudentService.getStudentByCode(this.orgId, codeOrName)
      .subscribe(
        data => {
          data = data[0];
          if (data) {
            this.studentInfo = data;
            this.addStudentForm.controls.fullNameAr.setValue(data.fullNameAr);
            this.addStudentForm.controls.firstNameAr.setValue(data.firstNameAr);
            this.addStudentForm.controls.lastNameAr.setValue(data.lastNameAr);
            this.addStudentForm.controls.fullNameEnglish.setValue(data.fullNameEn);
            this.addStudentForm.controls.firstNameEn.setValue(data.firstNameEn);
            this.addStudentForm.controls.lastNameEn.setValue(data.lastNameEn);
            this.addStudentForm.controls.gender.setValue(data.gender);
            this.addStudentForm.controls.email.setValue(data.emailAddress1);
            this.addStudentForm.controls.phoneNumber.setValue(data.personalMob1);
            this.addStudentForm.controls.address.setValue((this.globals.lang == 'ar') ? data.addressL1Ar : data.addressL1En);
            this.addStudentForm.controls.nationalId.setValue(data.nidNo);
            this.addStudentForm.controls.studentState.setValue(data.stuStatusid);
            this.addStudentForm.controls.semester.setValue((this.globals.lang == 'ar') ? this.semesterDes.semesterNameAr : this.semesterDes.semesterNameEn);
            this.addStudentForm.controls.batch.setValue(data.currentGradeid);
            this.addStudentForm.controls.matNo.setValue(data.stuCode);
            this.getStudentRepeaterSubjects();
            // this.updateTable();
            this.showStudentInfo = true;
          } else {
            this.toastrService.warning(this.translate.instant('STUDENT_NOT_FOUND'));
          }
          this.showLoader = false;
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          this.showLoader = false;
        }
      );
  }

  candChangeImage(event: any) {
    this.candImageFile = null;
    this.candImageUrl = null;
    this.candUploadImage = null;
    let typesAccept = ['image/png', 'image/jpeg', 'image/jpg'];
    // Max size 200 MEGA
    var maxSize = 209715200;

    if (event.target.files.length > 0) {
      var currentFile = event.target.files[0];
      console.log("file type: " + currentFile.type);

      // if ((currentFile.type == oldExcel || currentFile.type == excel) && currentFile.size <= maxSize) {
      if ((typesAccept.includes(currentFile.type)) && currentFile.size <= maxSize) {
        this.candImageFile = event.target.files[0];
        var reader = new FileReader();

        reader.readAsDataURL(currentFile); // read file as data url

        reader.onload = (event) => { // called once readAsDataURL is completed
          this.candImageUrl = event.target?.result;
        }
        this.candUploadImage = currentFile;
        console.log("accepted extention");
        return true;
      } else {
        console.log(currentFile.type);
        console.log("wrong extention");
        //this.basicData.controls.userImage.reset();
        this.candUploadImage = '';
        //this.basicData.controls.userImage.markAsDirty();
        //this.basicData.controls.userImage.markAsTouched();
        if (currentFile.size > maxSize) {
          this.toastrService.error(this.translate.instant('MAX_FILE_SIZE_200_MB'));
        }
        return false;
      }
    }
    else {
      return false;
    }
  }

  handleUploadFile() {
    let formData = new FormData();

    let fname = this.candImageFile.name.split('.').slice(0, -1).join('.')
    let fext = this.candImageFile.name.split('.').pop()
    this.candImageFileName = fname + "_" + Date.now() + "." + fext
    formData.append('file', this.candImageFile, this.candImageFileName);

    this.fileService.uploadFile(formData).subscribe(
      data => {
        // this.updateCandBasicData()
      },
      error => {
        // this.creating = false
        this.toastrService.warning(this.translate.instant("CAN_NOT_UPLOAD_USER_IMAGE"));
      }
    );
  }

  initFormDropDownsFields() {
    // this.studentStates = [{ key: 'repeater', value: this.translate.instant('REPEATER') }, { key: 'audit', value: this.translate.instant('AUDIT') }];
    this.semesters = [{ key: 'fall', value: this.translate.instant('FALL') }, { key: 'spring', value: this.translate.instant('SPRING') }];
    // this.batchs = [{ key: 'batch_1', value: this.translate.instant('BATCH_1') }, { key: 'batch_2', value: this.translate.instant('BATCH_2') }];
  }

  updateTable() {
    $("#datatable").DataTable().destroy();
    setTimeout(() => {
      this.table = $("#datatable").DataTable({

        // dom: 'Bfrtip',
        pagingType: 'simple_numbers',
        // responsive: true,
        // columnDefs: [
        //   { responsivePriority: 1, targets: 0 },
        //   { responsivePriority: 10001, targets: 4 },
        //   { responsivePriority: 2, targets: -2 }
        // ],
        // rowReorder: true,
        // "columnDefs": [
        //   { orderable: true, className: 'reorder', targets: [0] },
        //   { orderable: false, targets: '_all' }
        // ],
        // pageLength: 5,
        paging: false,
        searching: false,
        ordering: false,
        lengthChange: false,
        info: true,
        search: {
          searchPlaceholder: "Search",
        },
        language: {
          search: "",
          searchPlaceholder: "Search",
        },
        // buttons: [{
        //   extend: 'excelHtml5',
        //   text: '<span style="font-size: 3em; color: green;"><i class="fas fa-file-excel fa-sm"></i></span>',
        //   titleAttr: 'EXCEL',
        //   exportOptions: {
        //     columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]
        //   },
        //   className: 'datatable_custom_buttons',
        // }],
      });

      let dataTableButtonsDiv = <HTMLElement>document.getElementsByClassName('dt-buttons')[0];
      if (dataTableButtonsDiv != null) {
        dataTableButtonsDiv.style.padding = '0px 15px 0px 15px';
      }
      // Test datatable function start
      // console.log(table.rows({ search: 'applied', order: 'applied' }).data());
      // table.on('row-reordered', function (e: any, details: any, edit: any) {
      // console.log(table.rows({order:'current'}).data());
      // console.log('row-reordered');
      // console.log(table.rows().data());
      // var indexes = table.rows().indexes().toArray();
      // for (var r = 0; r < indexes.length; r++) {
      //   //get row data
      //   var data = table.row(indexes[r]).data();
      //   console.log(data);
      // }
      // });
      // Test datatable function end

    }, 1);

  }

  addRepeater() {
    // repeaterSubjectCode: any = "";
    // repeaterSubjectName: any = "";
    // repeaterAcademicYear: any = "";
    // repeaterSemester: any = "";
    // repeaterBatch: any = "";
    // repeaterStatus: any = "";
    this.showRepeaterTableError = false;
    if (this.repeaterSubjectId > 0 && this.repeaterBatchId > 0 && this.repeaterStatusId > 0) {
      this.addStudentSubjectRepeater();

    } else {
      this.showRepeaterTableError = true
    }

    // console.log(this.repeaterSubjectCode);
    // console.log("validate and add repeaters to table");
  }

  removeRepeater() {
    if (this.currentRepeaterId) {
      this.deleteStudentSubjectById(this.currentRepeaterId);
      // this.repeaters.splice(this.currentRepeaterIndex, 1)
      // this.toastrService.success(this.translate.instant('DELETED_SUCCESSFULLY'));
      // this.updateTable();
    } else {
      this.toastrService.error(this.translate.instant('REPEATER_NOT_FOUND'));
    }
  }

  updateCurrentRepeaterId(id: number) {
    // this.currentRepeaterIndex = index;
    this.currentRepeaterId = id;
  }

  addStudentRepeaters() {
    console.log("submit student repeaters");
  }

  getAllCourses() {
    // this.showLoader = true;
    this.coursesService.getAllCourses()
      .subscribe(
        data => {
          this.courses = data;
          // this.updateTable();
        },
        error => {

          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          // this.showLoader = false

        },
        // () => this.showLoader = false
      );
  }

  getSubjectName(courseId: any) {
    let course = this.courses.filter((i: any) => i.id == courseId)[0];
    if (course) {
      this.repeaterSubjectName = (this.globals.lang == 'ar') ? course.subjectNameAr : course.subjectNameEn;
      this.getGradeBySubjectId(courseId);
    } else {
      this.repeaterSubjectName = '';
      this.toastrService.warning(this.translate.instant('COURSE_NOT_FOUND'));
    }
  }

  getAllGradeSubject() {
    this.gradeSubjectService.getALLBatches()
      .subscribe(
        data => {
          this.batchs = data;
        },
        error => {
          console.log('can\'t get grades from backend');
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          this.showLoader = false

        },
        () => this.showLoader = false
      );
  }

  deleteStudentSubjectById(id: number) {
    this.loadingStudentRepeater = true;
    this.enrollmentAcceptedStudentService.deleteStudentSubjectById(id)
      .subscribe(
        data => {
          if (data.sts == "SUCCESS") {
            this.toastrService.success(this.translate.instant('DELETED_SUCCESSFULLY'));
            this.getStudentRepeaterSubjects();
          } else {
            this.toastrService.warning(this.translate.instant('CAN_NOT_DELETE_SUBJECT'));
            this.updateTable();
          }
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_DELETE_SUBJECT'));
          this.loadingStudentRepeater = false;
          this.updateTable();

        },
        () => {
          this.loadingStudentRepeater = false;
          this.repeaterBatchName = '';
          this.repeaterBatchId = '';
          this.repeaterSubjectName = '';
        }
      );
  }

  getGradeBySubjectId(id: number) {
    this.enrollmentAcceptedStudentService.getGradeBySubjectId(this.orgId, id)
      .subscribe(
        data => {
          if (data.length > 0) {
            data = data[0];
            this.repeaterBatchId = data.gradeid;
            console.log(data);
            let batch = this.batchs.filter((i: any) => i.id == this.repeaterBatchId)[0];
            console.log(batch);
            this.repeaterBatchName = (this.globals.lang == 'ar') ? batch.gradeNameAr : batch.gradeNameEn;
          } else {
            this.repeaterBatchName = '';
            this.repeaterBatchId = '';
            this.toastrService.warning(this.translate.instant('BATCH_NOT_FOUND_AT_BACKEND'));
          }

        },
        error => {
          this.repeaterBatchName = '';
          this.repeaterBatchId = '';
          this.toastrService.error(this.translate.instant('CAN_NOT_BATCH_FROM_BACKEND'));

        }
      );
  }

  getStudentRepeaterSubjects() {
    this.loadingStudentRepeater = true;
    this.enrollmentAcceptedStudentService.getStudentRepeaterSubjects(this.orgId, this.academicYear, this.semesterCode, this.studentInfo.id)
      .subscribe(
        data => {
          if (data.length > 0) {
            this.repeaters = data;
            this.repeaters.map((element:any) => {
              let subjectId = element.subjectid;
              let course = this.courses.filter((i: any) => i.id == subjectId)[0];
              element.subjectCode = "";
              if(course)
              {
                element.subjectCode = course.subjectCode;
              }
              return element;
              }
            );
          }else{
            this.repeaters = [];
          }

        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_STUDENT_SUBEJCTS_FROM_BACKEND'));

        },
        () => {
          this.loadingStudentRepeater = false;
          this.repeaterBatchName = '';
          this.repeaterBatchId = '';
          this.repeaterSubjectName = '';
          this.updateTable();
        }
      );
  }

  addStudentSubjectRepeater() {
    let course = this.courses.filter((i: any) => i.id == this.repeaterSubjectId)[0];
    let batch = this.batchs.filter((i: any) => i.id == this.repeaterBatchId)[0];
    let staus = this.subjectStates.filter((i: any) => i.id == this.repeaterStatusId)[0];
    if (course && batch && staus) {
      let studSubjectObj = {
        orgid: this.orgId,
        yearid: this.academicYear,
        semesterid: this.semesterCode,
        studentid: this.studentInfo.id,
        gradeid: batch.id,
        subjectid: course.id,
        ssstatusid: staus.id,
        remarks: staus.sstatusNameEn,
        active: 'Yes',
      };
      this.loadingStudentRepeater = true;
      // Remove this push when get repeater subject from backend
      // this.repeaters.push({
      //   subjectCode: course.subjectCode,
      //   subjectName: (this.globals.lang == 'ar') ? course.subjectNameAr : course.subjectNameEn,
      //   academicYear: this.academicYear,
      //   semester: this.semesterCode,
      //   batch: (this.globals.lang == 'ar') ? batch.gradeNameAr : batch.gradeNameEn,
      //   status: (this.globals.lang == 'ar') ? staus.sstatusNameAr : staus.sstatusNameEn,
      // });

      this.enrollmentAcceptedStudentService.addStudentSubjectRepeater(this.username, studSubjectObj)
        .subscribe(
          data => {
            if(data.sts == "SUCCESS")
            {
              this.toastrService.success(this.translate.instant('ADDED_SUCCESSFULLY'));
              this.getStudentRepeaterSubjects();
            }else{
              this.toastrService.warning(this.translate.instant('CAN_NOT_ADD_STUDENT_SUBJECT_AT_BE'));
              this.updateTable();
            }
          },
          error => {
            this.toastrService.error(this.translate.instant('CAN_NOT_ADD_STUDENT_SUBJECT_AT_BE'));
            this.loadingStudentRepeater = false;
            this.updateTable();

          },
          () => {
            this.loadingStudentRepeater = false;
            this.repeaterBatchName = '';
            this.repeaterBatchId = '';
            this.repeaterSubjectName = '';
          }
        );
    } else {
      this.toastrService.warning(this.translate.instant('INPUT_NOT_FOUND_AT_BACKEND'));
    }
  }

}
